



















































import { Component, Vue } from 'vue-property-decorator';
import { yunnanDataViewServer } from '@/api/installServer';
import dayJs from 'dayjs';
import ListDialog from '../../yunnanDataView/unit/box9/box-9-unit-1.vue';

@Component({
  components: { ListDialog },
})
export default class DataBox2 extends Vue {
  private $echarts: any;
  private dataForm: any = {};
  private topDataObj: any = {};
  private totalAll: any = {};
  private chartType: any = '';
  private topDeptId: any = '';

  mounted() {
    // this.getData({});
  }

  goList(type: any) {
    let startTime: any = '';
    let endTime: any = '';
    switch (this.chartType) {
      case 'year':
        startTime = dayJs(new Date()).format('YYYY') + '-01-01 00:00:00';
        endTime = dayJs(new Date()).format('YYYY') + '-12-31 23:59:59';
        break;
      case 'month':
        startTime =
          dayJs()
            .startOf('month')
            .format('YYYY-MM-DD') + ' 00:00:00';
        endTime =
          dayJs()
            .endOf('month')
            .format('YYYY-MM-DD') + ' 23:59:59';
        break;
      case 'day':
        startTime = dayJs(new Date()).format('YYYY-MM-DD') + ' 00:00:00';
        endTime = dayJs(new Date()).format('YYYY-MM-DD') + ' 23:59:59';
        break;
    }
    const ref: any = this.$refs['dialogRef'];
    const data: any = {
      startTime: startTime,
      endTime: endTime,
      type: type,
    };
    console.log(data);
    ref.showDialog(data);
  }

  getData(opts: any) {
    this.topDeptId = opts.topDeptId || '';
    yunnanDataViewServer
      .getWorkTicketCollect({
        topDeptId: opts.topDeptId || null,
      })
      .then((res: any) => {
        this.topDataObj = res.data;
      })
      .catch((e: any) => {
        console.log(e);
      });

    this.getChartData('year');
  }

  getChartData(type: any) {
    const map: any = {
      day: 'CURRENT_DAY',
      month: 'CURRENT_MONTH',
      year: 'CURRENT_YEAR',
    };

    const form: any = {
      dateRangeType: map[type],
      topDeptId: this.topDeptId,
    };

    this.chartType = type;

    yunnanDataViewServer
      .getWorkTicketDayDistributed(form)
      .then((res: any) => {
        this.dataForm = res.data;
        this.showCharts();
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  private showCharts() {
    const nameArr: any = [];
    const dataZoomMap: any = {
      day: [0, 100],
      month: [0, 20],
      year: [0, 100],
    };

    const valueArrAll: any = {
      高处作业: [],
      吊装作业: [],
      有限空间: [],
      动火作业: [],
      临时用电: [],
    };
    const totalAll: any = {
      高处作业: 0,
      吊装作业: 0,
      有限空间: 0,
      动火作业: 0,
      临时用电: 0,
    };

    this.totalAll = totalAll;

    for (const key in this.dataForm) {
      this.dataForm[key].forEach((item: any) => {
        nameArr.indexOf(item.xaxis) === -1 && nameArr.push(item.xaxis);
        valueArrAll[key] && valueArrAll[key].push(item.yaxis); // 发现隐患
        totalAll[key] += Number(item.yaxis);
      });
    }

    const barWidth: any = 5;
    const barBorderRadius: any = 4;
    const echartsA = this.$echarts.init(document.getElementById('house-charts-9-1') as any);
    const optionA = {
      title: {
        text: '',
        subtext: '',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['高处作业', '吊装作业', '有限空间', '动火作业', '临时用电'],
        x: 'right',
        y: 'top',
        textStyle: {
          fontSize: 10, //字体大小
          color: '#999', //字体颜色
        },
        itemWidth: 10, // 设置宽度
        itemHeight: 10, // 设置高度
        itemGap: 10, // 设置间距
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '20%',
        top: '22%',
        containLabel: true,
      },
      yAxis: [
        {
          type: 'value',
          minInterval: 1,
          // name: '',
          axisLabel: {
            formatter: function(i: any) {
              const l = (3 - i.toString().length) * 2 + 1;
              const r = i + Array(l).join('\ ');
              return r;
            },
            textStyle: {
              color: '#888',
              fontSize: 11,
            },
          },
          splitLine: {
            lineStyle: {
              color: '#ccc',
              type: 'dashed',
            },
          },
          boundaryGap: [0, 0.01],
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
        },
      ],
      xAxis: {
        triggerEvent: true,
        data: nameArr,
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: '#888',
            fontSize: 10,
          },
        },
      },
      dataZoom: [
        {
          type: 'slider',
          id: 'heng',
          xAxisIndex: [0],
          filterMode: 'none', // 当前数据窗口外的数据，被 过滤掉。即 会 影响其他轴的数据范围。每个数据项，只要有一个维度在数据窗口外，整个数据项就会被过滤掉。
          start: dataZoomMap[this.chartType][0], // 显示0% 开始的数据， 到 10%的数据结束，相当展示前10%的数据，做到降采样
          end: dataZoomMap[this.chartType][1],
          bottom: '12%',
          left: '4%',
          right: '4%',
          height: 4,
          handleSize: '400%',
          handleStyle: {
            color: '#73a0fa',
          },
          borderColor: 'transparent',
          backgroundColor: 'rgba(0,0,0,0.04)',
          dataBackground: {
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          fillerColor: '#73a0fa',
          textStyle: {
            color: 'transparent',
          },
        },
      ],
      series: [
        {
          name: '高处作业',
          type: 'bar',
          barWidth: barWidth,
          data: valueArrAll['高处作业'],
          color: 'rgba(0,118,186,0.75)',
          itemStyle: {
            normal: {
              barBorderRadius: barBorderRadius,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        {
          name: '吊装作业',
          type: 'bar',
          barWidth: barWidth,
          data: valueArrAll['吊装作业'],
          color: 'rgba(0,149,219,0.75)',
          itemStyle: {
            normal: {
              barBorderRadius: barBorderRadius,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        {
          name: '有限空间',
          type: 'bar',
          barWidth: barWidth,
          data: valueArrAll['有限空间'],
          color: 'rgba(4,149,175,0.75)',
          itemStyle: {
            normal: {
              barBorderRadius: barBorderRadius,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        {
          name: '动火作业',
          type: 'bar',
          barWidth: barWidth,
          data: valueArrAll['动火作业'],
          color: 'rgba(0,148,137,0.75)',
          itemStyle: {
            normal: {
              barBorderRadius: barBorderRadius,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        {
          name: '临时用电',
          type: 'bar',
          barWidth: barWidth,
          data: valueArrAll['临时用电'],
          color: 'rgba(4,149,103,0.75)',
          itemStyle: {
            normal: {
              barBorderRadius: barBorderRadius,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
      ],
    };

    echartsA.setOption(optionA);
  }
}
